<template>
  <div id="base-icon" :style="svgStyles">
    <div
      v-if="multiplatform"
      class="svg-icon"
      v-html="
        require(`!!html-loader!@/assets/svg/${getAppName}/icon-${this.icon}.svg`)
      "
    />

    <div
      v-else
      class="svg-icon"
      v-html="require(`!!html-loader!@/assets/svg/icon-${this.icon}.svg`)"
    />
  </div>
</template>

<script>
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "BaseIcon",
  props: {
    icon: {
      type: String
    },
    size: {
      type: String,
      default: "20px"
    },
    padding: {
      type: String,
      default: "0px"
    },
    hover: {
      type: Boolean,
      default: false
    },
    multiplatform: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getAppName() {
      return appIdentifier();
    },
    svgStyles: function() {
      return {
        position: "relative",
        height: this.size,
        width: this.size,
        padding: this.padding
      };
    }
  },
  mounted() {
    if (this.hover) {
      this.$el.querySelector("svg").classList.add("onHover");
    }
  }
};
</script>

<style lang="scss">
#base-icon {
  pointer-events: none;

  .svg-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .onHover {
    pointer-events: auto;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
